<mat-expansion-panel [expanded]="true" [disabled]="true" class="date-time-question-expansion-panel">
  <mat-expansion-panel-header  class="mat-header">
    <opt-question-header [dates]="dates" [isMandatory]="bookingQues?.question?.mandatory"
      [questionNumber]="questionNumber" [questionText]="bookingQues?.question?.questionText"
      (popselectedDates)="RecveselectedDates($event)"></opt-question-header>
  </mat-expansion-panel-header>
  <div class="mmc_flex--container fd-col date-time-question-body">
    <div class="mmc_flex__item m1 mr-3 p25" style="height: 45px;" *ngIf="isAnswerDate || isAnswerDateAndTime">
      <mat-form-field appearance="outline" class="pw-txt-s3" style="height: 40px;">
        <mat-label style="margin-top: -15px; margin-left: 10px;">{{"QUESTIONPOPUP.Date" | optimotranslate}}</mat-label>
        <input matInput [matDatepicker]="picker" [value]="getDateValue()"
          (dateChange)="dateChanged($event)" readonly>
        <mat-icon matSuffix (click)="picker.open()" style="cursor: pointer; color: rgba(0,0,0,.54);">event</mat-icon>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="mmc_flex__item m1 mr-3 p25" style="height: 45px;" *ngIf="isAnswerTime || isAnswerDateAndTime">
      <mat-form-field appearance="outline" class="pw-txt-s3" style="height: 40px;">
        <mat-label style="margin-top: -15px; margin-left: 10px;">{{"QUESTIONPOPUP.Time" | optimotranslate}}</mat-label>
        <input matInput type="time" 
          [value]="getTimeInputValue()" 
          (change)="onTimeInputChange($event)"
          placeholder="{{'QUESTIONPOPUP.Time' | optimotranslate | uppercase}}">
      </mat-form-field>
    </div>

    <div class="mmc_flex__item m1 mr-3"
      [ngClass]=" isAnswerTime && isAnswerDate  ? 'p50' : !isAnswerTime && isAnswerDate ? 'p75' : 'p75'">
      <button mat-stroked-button (click)="clearDate($event)" style="margin-left: 5px;
      margin-top: 2px;
      height: 34px;">{{"QUESTIONPOPUP.Clear" | optimotranslate}}</button>
    </div>

  </div>

  <div>
    <input 
    *ngIf="bookingQues?.question?.allowUndecided" 
    type="checkbox" 
    (change)="inputCheckChanged($event)" 
    [(ngModel)]="bookingQues.question.undecided">
    <label  *ngIf="bookingQues?.question?.allowUndecided"> Answer later</label>
  </div>
</mat-expansion-panel>
<div class="wp_flex--container flex-column question-list " class="mt-4 conditional-question">
  <div class="wp_flex__item--inherit wp_flex__item--vcenter">
    <opt-question class="w-100" [isMandatory]="false" [questionNumber]="questionNumber +'.1'"
      [questions]="bookingQues.conditionalBookingQuestions" [answeredQuestionIds]="answeredQuestionIds"
      (questionAnswerOutput)="conditionalQuestionAnswerChange($event)"></opt-question>
  </div>
</div>
